module.exports = __webpack_public_path__ + "static/media/carrer.3e7a5cda.jpg";